import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { getRequestData } from '@/utils';
import {
  qryUnreadBltCounts,
  qryReceivedBltList,
  qryEnumberList4Staff,
  agentEvoucherQry,
  commItemQuery,
  qryOrderInfo4DRMBsnl,
  queryOssOrderCountBsnl,
  qryOrgBindSubsSummary,
  qryTaskCntBsnl,
} from '@/pages/Home/services/home';
import { menuKey } from '@/pages/Home/config';

const {
  pendingOrders,
  provisionOrders,
  faultOrders,
  totalAccount,
  pendingTicket,
  pendingLeads,
} = menuKey;

export default {
  namespace: 'home',
  state: {
    unreadBltCounts: null,
    receivedBltList: [],
    topupBalance: null,
    topupNumber: null,
    displayTopupBalance: null,
    commissionBalance: null,
  },
  effects: {
    *qryUnreadBltCounts({ payload }, { call, put }) {
      const response = yield call(qryUnreadBltCounts, payload);
      const { counts } = getRequestData(response, false);
      yield put({
        type: 'save',
        payload: {
          unreadBltCounts: counts,
        },
      });
    },

    *qryReceivedBltList({ payload }, { call, put }) {
      const response = yield call(qryReceivedBltList, payload);
      const receivedBltList = getRequestData(response, false);
      if (!isEmpty(receivedBltList)) {
        yield put({
          type: 'save',
          payload: {
            receivedBltList,
          },
        });
      }
    },

    // 恒河水是代理商默认一个，所有员工也用同一个，再调用已有查询代理商ENumber余额
    *qryTopupBalance({ payload }, { call, put }) {
      const { staffId, orgId } = payload;
      const response = yield call(qryEnumberList4Staff, staffId);
      const enumberList = getRequestData(response, false);
      if (!isEmpty(enumberList)) {
        const data = yield call(agentEvoucherQry, { agentMSISDN: get(enumberList, ['0', 'enumber']), agentCode: orgId });
        const { evoucherObjList } = getRequestData(data);
        yield put({
          type: 'save',
          payload: {
            topupNumber: get(enumberList, ['0', 'enumber']),
            topupBalance: get(evoucherObjList, ['0', 'balValue']),
            displayTopupBalance: get(evoucherObjList, ['0', 'displayBalValue']),
          },
        });
      }
    },

    *qryCommissionBalance({ payload }, { call, put }) {
      const response = yield call(commItemQuery, payload);
      const { commTotalAmount } = getRequestData(response, false);
      yield put({
        type: 'save',
        payload: {
          commissionBalance: commTotalAmount,
        },
      });
    },

    *qryOrderInfo4DRMBsnl({ payload }, { call }) {
      const { params, callback } = payload;
      const response = yield call(qryOrderInfo4DRMBsnl, params);
      const { pageReqDto } = getRequestData(response, false);
      const pendingOrdersCount = get(pageReqDto, 'totalRecord');
      callback(pendingOrders, pendingOrdersCount);
    },

    *qryOssOrderCountBsnl({ payload }, { call }) {
      const { params, callback } = payload;
      const response = yield call(queryOssOrderCountBsnl, params);
      const { ossOrderCntRspDto } = getRequestData(response, false);
      const provisionOrdersCount = get(ossOrderCntRspDto, 'provTasks');
      const faultOrdersCount = get(ossOrderCntRspDto, 'ttTasks');
      callback(provisionOrders, provisionOrdersCount);
      callback(faultOrders, faultOrdersCount);
    },

    *qryOrgBindSubsSummary({ payload }, { call }) {
      const { params, callback } = payload;
      const response = yield call(qryOrgBindSubsSummary, params);
      const { total } = getRequestData(response, false);
      callback(totalAccount, total);
    },

    *qryTaskCntBsnl({ payload }, { call }) {
      const { params, callback } = payload;
      const response = yield call(qryTaskCntBsnl, params);
      const { taskCntRspDto } = getRequestData(response, false);
      const pendingTicketCount = get(taskCntRspDto, 'taskCnt');
      const pendingLeadsCount = get(taskCntRspDto, 'leadCnt');
      callback(pendingTicket, pendingTicketCount);
      callback(pendingLeads, pendingLeadsCount);
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
